import React from "react";
import Marquee from "react-fast-marquee";

export default function TikTokMarquee() {
  const items = [
    "@y666.suf",
    "▲ LIVE NOW",
    "NFG CRASH",
    "@y666.suf",
    "PRESS PLAY",
    "WORDWICH",
    "@y666.suf",
    "HANGMAN",
    "INTERACTIVE",
    "WORDWHEEL",
  ];
  return (
    <div
      data-testid="tiktok-marquee"
      className="relative py-5 md:py-6 border-y border-purple-400/20 bg-black overflow-hidden mask-marquee"
    >
      <Marquee speed={70} gradient={false} pauseOnHover>
        {items.concat(items).map((t, i) => (
          <span
            key={i}
            className="font-display font-black uppercase text-3xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tighter mx-6 md:mx-8 inline-flex items-center"
            style={{
              color: i % 3 === 0 ? "#B56CFF" : "#fff",
              WebkitTextStroke: i % 3 === 1 ? "1px #E8C547" : "0",
              WebkitTextFillColor: i % 3 === 1 ? "transparent" : undefined,
              textShadow: i % 3 === 0 ? "0 0 24px rgba(181,108,255,0.5)" : "none",
            }}
          >
            {t}
            <span className="mx-6 text-amber-500/60">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
